import { Core } from "@faire/design-tokens";
import { UpsellContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellContainer";
import { UpsellLayout } from "@faire/retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellLayout";
import { Button } from "@faire/web/slate/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";

export const NoTermsAndNonAutoAcceptedView: React.FC<{
  handleStartShopping: () => void;
}> = ({ handleStartShopping }) => {
  const imageUrl = useResponsiveValue({
    mobileAndAbove: MOBILE_HERO_IMAGE,
    tabletAndAbove: DESKTOP_HERO_IMAGE,
  });
  const size = useResponsiveValue({
    mobileAndAbove: MOBILE_SIZE,
    tabletAndAbove: DESKTOP_SIZE,
  });
  return (
    <UpsellLayout
      backgroundColor={Core.surface.info}
      onClose={handleStartShopping}
    >
      <UpsellContainer imageUrl={imageUrl} size={size} mobileOffset="-5%">
        <OwFNoTermsAndNonAutoAcceptedContent
          handleContinue={handleStartShopping}
        />
      </UpsellContainer>
      <Spacer height={{ mobileAndAbove: "4x", tabletAndAbove: "5x" }} />
    </UpsellLayout>
  );
};

const OwFNoTermsAndNonAutoAcceptedContent: React.FC<{
  handleContinue: () => void;
}> = ({ handleContinue }) => {
  return (
    <>
      <Typography variant="displaySSerifRegular">
        <StrictLocalMsg
          id="GF/Xtz"
          defaultMessage="We’ve got your request for more terms"
          description={{
            text: "Title explaining that the retailer's request for more terms is being processed",
            img: "https://cdn.faire.com/fastly/3120e0680d7c0e951fb36c91f2c9c67986776c27b03fba1e4635d5e4cbc6d1a6.png",
          }}
        />
      </Typography>
      <Spacer height={12} />
      <Typography>
        <StrictLocalMsg
          id="tsLcje"
          defaultMessage="You’ll hear from us soon. Until then, start planning how to stock your store from over 100,000 brands you’ll love on Faire."
          description={{
            text: "Subtitle explaining that the retailer will hear from us soon",
            img: "https://cdn.faire.com/fastly/3120e0680d7c0e951fb36c91f2c9c67986776c27b03fba1e4635d5e4cbc6d1a6.png",
          }}
        />
      </Typography>
      <Spacer height={{ mobileAndAbove: "4x", tabletAndAbove: "5x" }} />
      <Button
        variant="primary"
        onClick={handleContinue}
        data-test-id="apply-now"
      >
        <StrictLocalMsg
          id="p3oMhh"
          defaultMessage="Start shopping"
          description={{
            text: "Button to start shopping",
            img: "https://cdn.faire.com/fastly/4cb1c1fa1e12d676474108a2ac94fde05dd2dbb346e1cbea86ffa175a8b0d308.png",
          }}
        />
      </Button>
    </>
  );
};

const MOBILE_HERO_IMAGE =
  "https://cdn.faire.com/fastly/dfb6ff3e0a4733f46543ddcac3d4c634947e04a1c95a5a5957b90377e02f5b13.jpeg";
const MOBILE_SIZE = {
  width: 400,
  height: 267,
};

const DESKTOP_HERO_IMAGE =
  "https://cdn.faire.com/fastly/e4c895e312d0288e9181eaf281f6cd41446cc46eb89cbd8347f90976fff01bad.jpeg";
const DESKTOP_SIZE = {
  width: 608,
  height: 280,
};
